<template>
    <div class='card_bg'>
      <template v-if='successList.length'>
        <div v-for='(res,i) in successList' :key="i">
          <div class='result_desc_color result_desc_bold'>Swap request pending</div>
          <div class='result_desc_color success_result_intro'>We have added the following transaction/s to our log for your address:</div>
          <!--sender-->
          <div class='success_detail result_desc_color'>
            <div class='result_desc_bold'>{{getDepositAmountFromResult(res)}} {{getSenderToken()}}</div>
            <div>from</div>
            <a class='desc_decoration result_desc_bold' target='_blank' :href='getSenderAddressLink(res)'>{{getSender(res)}}</a>
          </div>
          <!--receiver-->
          <div class='success_detail result_desc_color'>
            You will receive another
            <a class='result_desc_bold' :href=getTransferTxLink(res) target="_blank">{{getSwapAmountFromResult(res)}} {{getReceiverToken()}}</a>
            in your address
            <a class='result_desc_bold desc_decoration' target='_blank' :href='getReceiverAddressLink(res)'>{{getReceiver(res)}}</a>
          </div>
        </div>
      </template>
      <template v-if='isShowNotTransferList'>
        <div v-for='(res,i) in notNeedTransferList' :key="i">
          <div class='result_desc_color not_need_transfer_desc'>
            The Deposit amount {{getDepositAmountFromResult(res)}} of Deposit transaction:<a :href='getDepositTxLink(res)' target='_blank'>{{getDepositTxHash(res)}}</a>
            a is not enough to swap
          </div>
        </div>
      </template>
    </div>
</template>

<script>
import utils from '../common/utils'
export default {
  name: 'swapResultView',
  props: {
    swapResult: {
      type: Array,
      default: function () {
        return []
      }
    },
    depositInfo: {
      type: Object,
      default: function () {
        return { swapType: -1, depositAddress: '', memo: '' }
      }
    }
  },
  data () {
    return {
      successList: [], // all success swap records
      notNeedTransferList: [], // all not need transfer records
      isShowNotTransferList: false
    }
  },
  methods: {
    getSenderToken () {
      let swapType = this.getSwapType()
      if (swapType === utils.SwapType.SwapTypeUnknown) {
        console.log('getSenderToken: can not get token of unknown swap type', swapType)
        return ''
      }
      if (utils.checkIsErc20Swap(swapType)) {
        return 'COS-ERC20'
      } else if (utils.checkIsBep2Swap(swapType)) {
        return 'COS-BEP2'
      } else if (utils.checkIsCosMainNetSwap(swapType)) {
        return 'native COS'
      }
      return ''
    },
    getReceiverToken () {
      let swapType = this.getSwapType()
      if (swapType === utils.SwapType.SwapTypeUnknown) {
        console.log('getSenderToken: can not get token of unknown swap type', swapType)
        return ''
      }
      if (utils.checkIsSwapToErc20(swapType)) {
        return 'COS-ERC20'
      } else if (utils.checkIsSwapToBep2(swapType)) {
        return 'COS-BEP2'
      } else if (utils.checkIsSwapToCosMainNet(swapType)) {
        return 'native COS'
      }
      return ''
    },
    getSwapType () {
      let key = utils.swapTypeKey
      if (this.depositInfo.hasOwnProperty(key)) {
        return this.depositInfo[key]
      }
      return utils.SwapType.SwapTypeUnknown
    },

    getSwapAmountFromResult (res) {
      if (utils.checkIsNotNullObj(res)) {
        let key = utils.swapAmountKey
        return this.getValFromRes(res, key)
      }
      return 0
    },

    getDepositAmountFromResult (res) {
      if (utils.checkIsNotNullObj(res)) {
        let key = utils.depositAmountKey
        return this.getValFromRes(res, key)
      }
      return 0
    },

    getSender (res) {
      let key = utils.resSenderKey
      return this.getValFromRes(res, key)
    },

    getReceiver (res) {
      let key = utils.resReceiverKey
      return this.getValFromRes(res, key)
    },

    getTxHash (res) {
      let key = utils.resTxHashKey
      return this.getValFromRes(res, key)
    },

    getDepositTxHash (res) {
      let key = utils.depositTxHashKey
      return this.getValFromRes(res, key)
    },

    getValFromRes (res, key) {
      if (utils.checkIsNotNullObj(res)) {
        if (res.hasOwnProperty(key)) {
          return res[key]
        }
      }
      return ''
    },

    getSenderAddressLink (res) {
      if (utils.checkIsNotNullObj(res)) {
        let swapType = this.getSwapType()
        let addr = this.getSender(res)
        if (utils.checkIsErc20Swap(swapType)) {
          return this.getEthAddressLink(addr)
        } else if (utils.checkIsBep2Swap(swapType)) {
          return this.getBnbAddressLink(addr)
        } else if (utils.checkIsCosMainNetSwap(swapType)) {
          return this.getCosMainNetAccountLink(addr)
        }
      }
      return ''
    },

    getReceiverAddressLink (res) {
      if (utils.checkIsNotNullObj(res)) {
        let swapType = this.getSwapType()
        let addr = this.getReceiver(res)
        if (utils.checkIsSwapToErc20(swapType)) {
          return this.getEthAddressLink(addr)
        } else if (utils.checkIsSwapToBep2(swapType)) {
          return this.getBnbAddressLink(addr)
        } else if (utils.checkIsSwapToCosMainNet(swapType)) {
          return this.getCosMainNetAccountLink(addr)
        }
      }
      return ''
    },

    getDepositTxLink (res) {
      if (utils.checkIsNotNullObj(res)) {
        let swapType = this.getSwapType()
        let txHash = this.getDepositTxHash(res)
        if (utils.checkIsErc20Swap(swapType)) {
          return this.getEthTxLink(txHash)
        } else if (utils.checkIsBep2Swap(swapType)) {
          return this.getBnbTxLink(txHash)
        } else if (utils.checkIsCosMainNetSwap(swapType)) {
          return this.getCosMainNetTxLink(txHash)
        }
      }
      return ''
    },

    getTransferTxLink (res) {
      if (utils.checkIsNotNullObj(res)) {
        let swapType = this.getSwapType()
        let txHash = this.getTxHash(res)
        if (utils.checkIsSwapToErc20(swapType)) {
          return this.getEthTxLink(txHash)
        } else if (utils.checkIsSwapToBep2(swapType)) {
          return this.getBnbTxLink(txHash)
        } else if (utils.checkIsSwapToCosMainNet(swapType)) {
          return this.getCosMainNetTxLink(txHash)
        }
      }
      return ''
    },

    getEthAddressLink (addr) {
      let isDev = utils.checkIsDev()
      if (isDev) {
        return 'https://ropsten.etherscan.io/address/' + addr
      }
      return 'https://etherscan.io/address/' + addr
    },

    getEthTxLink (txHash) {
      let isDev = utils.checkIsDev()
      if (isDev) {
        return 'https://ropsten.etherscan.io/tx/' + txHash
      }
      return 'https://etherscan.io/tx/' + txHash
    },

    getCosMainNetAccountLink (addr) {
      let isDev = utils.checkIsDev()
      if (isDev) {
        return 'https://testexplorer.contentos.io/#/account/' + addr
      }
      return 'https://explorer.contentos.io/#/account/' + addr
    },

    getCosMainNetTxLink (txHash) {
      let isDev = utils.checkIsDev()
      if (isDev) {
        return 'https://testexplorer.contentos.io/#/tx/' + txHash
      }
      return 'https://explorer.contentos.io/#/tx/' + txHash
    },

    getBnbAddressLink (addr) {
      let isDev = utils.checkIsDev()
      if (isDev) {
        return 'https://testnet-explorer.binance.org/address/' + addr
      }
      return 'https://explorer.binance.org/address/' + addr
    },

    getBnbTxLink (txHash) {
      let isDev = utils.checkIsDev()
      if (isDev) {
        return 'https://testnet-explorer.binance.org/tx/' + txHash
      }
      return 'https://explorer.binance.org/tx/' + txHash
    },

    classifySwapResults (list) {
      let key = utils.resultStatusKey
      let sucList = []
      let notTransferList = []
      for (let res of list) {
        if (res.hasOwnProperty(key)) {
          let status = res[key]
          if (status === utils.SwapResult.SwapResultSuccess) {
            sucList.push(res)
          } else if (status === utils.SwapResult.SwapResultNotNeedTransfer) {
            notTransferList.push(res)
          }
        }
      }
      this.successList = sucList
      this.notNeedTransferList = notTransferList
      if (this.successList.length < 1 && this.notNeedTransferList.length > 0) {
        this.isShowNotTransferList = true
      }
    }

  },
  watch: {
    swapResult (val) {
      this.classifySwapResults(val)
    }
  },
  created () {
    this.classifySwapResults(this.swapResult)
  }

}
</script>

<style scoped>
  .card_bg {
    width: 50%;
    display: flex;
    display: -ms-flex;
    flex-direction: column;
    justify-items: center;
    justify-content: center;
    padding: 30px;
    box-sizing: border-box;
    border: 1px solid #6a6a6a;
    border-radius: 4px;
    margin-bottom: -35px;
    text-align: center;
    font-size: 16px;
    word-break: break-word;
    word-wrap: break-word;
  }

  .result_desc_color {
    color: #6a6a6a;
  }

  .result_desc_bold {
    font-weight: bold;
  }

  .desc_decoration {
    text-decoration: underline;
  }

  .success_result_intro {
    margin-top: 20px;
  }

  .success_detail {
    margin-top: 20px;
  }

  .not_need_transfer_desc {
    margin-top: 15px;
  }

  @media (max-width: 768px) {
    .card_bg {
      width: 80%;
    }
  }
</style>
